import { createContext } from 'react'

//Types
import Info from 'types/info'

export const InfoContext = createContext<Info | undefined>(undefined)